import theme from 'config/theme';
import { getUrlParams } from 'helpers/utils';

export const recipientCategoryOptions = [
  {
    label: 'Organizations',
    value: 'ORGANIZATION',
    isGroup: true,
    children: [
      { label: 'PAC', value: 'PAC' },
      { label: 'Advocacy / 501(c)4', value: '501C4' },
      { label: 'Charitable Nonprofit / 501(c)3', value: '501C3' },
      { label: 'Other', value: 'OTHER' },
    ],
  },
  {
    label: 'Ballot measures',
    value: 'BALLOT_MEASURE',
    isGroup: false,
  },
  {
    label: 'Federal Candidates',
    value: 'FEDERAL_CANDIDATE',
    isGroup: true,
    children: [
      { label: 'US Senate', value: 'US_SENATE' },
      { label: 'US House', value: 'US_HOUSE' },
      { label: 'Other', value: 'US_OTHER' },
    ],
  },
  {
    label: 'State Candidates',
    value: 'STATE_CANDIDATE',
    isGroup: true,
    children: [
      { label: 'Governor', value: 'STATE_GOVERNOR' },
      { label: 'Other Statewide Executive', value: 'STATE_OTHER_EXEC' },
      { label: 'State Supreme Court Justice', value: 'STATE_SUPREME_COURT_JUSTICE' },
      { label: 'State Legislator', value: 'STATE_LEGISLATOR' },
      { label: 'Other', value: 'STATE_OTHER' },
    ],
  },
  {
    label: 'Local Candidates',
    value: 'LOCAL_CANDIDATE',
    isGroup: false,
  },
];

// Sets for categorizing type filter values into API parameters
export const RECIPIENT_FILTER_CATEGORIES = new Set([
  'FEDERAL_CANDIDATE',
  'STATE_CANDIDATE',
  'LOCAL_CANDIDATE',
  'ORGANIZATION',
  'BALLOT_MEASURE',
]);

export const FEDERAL_OFFICES = new Set(['US_SENATE', 'US_HOUSE', 'US_OTHER']);

export const STATE_OFFICES = new Set([
  'STATE_GOVERNOR',
  'STATE_OTHER_EXEC',
  'SUPREME_COURT_JUSTICE',
  'STATE_LEGISLATOR',
  'OTHER',
]);

export const ORGANIZATION_TYPES = new Set(['PAC', '501C4', '501C3', 'OTHER']);

export const categorizeTypeFilters = types => {
  const result = {
    recipient_filter_categories: [] as string[],
    federal_offices: [] as string[],
    state_offices: [] as string[],
    local_offices: [] as string[],
    organization_types: [] as string[],
  };

  for (const type of types) {
    if (RECIPIENT_FILTER_CATEGORIES.has(type)) {
      result.recipient_filter_categories.push(type);
    } else if (FEDERAL_OFFICES.has(type)) {
      result.federal_offices.push(type);
    } else if (STATE_OFFICES.has(type)) {
      result.state_offices.push(type);
    } else if (ORGANIZATION_TYPES.has(type)) {
      result.organization_types.push(type);
    }
  }

  return result;
};

const { urlPrimaryColor, urlSecondaryColor } = getUrlParams();

export const primaryColor = urlPrimaryColor || theme.colors.inkBlue;
export const secondaryColor = urlSecondaryColor || theme.colors.white;
